import { ConnectionPositionPair, Overlay, OverlayRef } from '@angular/cdk/overlay';
import { CdkPortal } from '@angular/cdk/portal';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'pcs-select-menu',
  template: `
    <ng-container *ngIf="attachOnBody(); else inline">
      <ng-container *cdkPortal>
        <div class="menu dropdown-menu">
          <ng-container *ngTemplateOutlet="selectionItems;"></ng-container>
        </div>
      </ng-container>
    </ng-container>
    <ng-template #inline>
      <ng-container *ngTemplateOutlet="selectionItems;"></ng-container>
    </ng-template>
  `,
  styleUrls: ['./select-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectMenuComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() container: 'body' | null = null;

  @Output() closed = new EventEmitter();

  @ViewChild(CdkPortal, {static: false}) private portal: CdkPortal;
  @ContentChild(TemplateRef) selectionItems: TemplateRef<unknown>;

  private overlayRef: OverlayRef;
  private subscription = new Subscription();

  constructor(
    private readonly overlay: Overlay,
    private readonly elementRef: ElementRef,
    private readonly renderer: Renderer2
  ) {
  }

  ngOnInit() {
    if (!this.attachOnBody()) {
      this.renderer.addClass(this.elementRef.nativeElement, 'dropdown-menu');
    }
  }

  ngAfterViewInit() {
    if (this.attachOnBody()) {
      this.createOverlay();
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.removeOverlay();
  }

  attachOnBody() {
    return this.container === 'body';
  }

  private createOverlay() {
    if (!this.overlayRef) {
      this.overlayRef = this.overlay.create({
        positionStrategy: this.positionStrategy(),
        width: this.elementRef.nativeElement.getBoundingClientRect().width,
        scrollStrategy: this.overlay.scrollStrategies.reposition({autoClose: true})
      });

      this.overlayRef.attach(this.portal);
      this.subscription.add(this.overlayRef.detachments().subscribe(() => this.closed.emit()));
    }
  }

  private positionStrategy() {
    const positions: ConnectionPositionPair[] = [
      {
        originX: 'center',
        originY: 'top',
        overlayX: 'center',
        overlayY: 'bottom',
        offsetY: 1,
      }
    ];

    return this.overlay.position()
      .flexibleConnectedTo(this.elementRef.nativeElement)
      .withPositions(positions);
  }

  private removeOverlay() {
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }
}
